import { observer, inject } from 'mobx-react'
import _ from 'lodash'
import { useState } from 'react'

import { SECURITY_TYPES_TEXT } from '../../../../constants'
import { HelpIcon, TooltipText } from '../../../../components'
import { placeholderSymbolReplace, numberToDollars, withRouterProps } from '../../../../utils'
import {
  TableTitle,
  TableHeader,
  TableList,
  TableRow,
  SortArrow,
  BalanceLabel,
  Balance,
} from './InstitutionalInvestmentsGroupStyle'
import InvestmentGroupItem from './InvestmentGroupItem'

const InstitutionalInvestmentsGroup = props => {
  const [state, setState] = useState({ sortBy: 'balance', sortOrder: 'desc' })

  const toggleSortOrder = () => {
    let { sortOrder } = state
    sortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
    setState({ sortOrder })
  }

  const handleSortChange = sortBy => {
    const { sortBy: currentSortBy } = state
    if (sortBy === currentSortBy) {
      toggleSortOrder()
    } else {
      setState({ sortBy, sortOrder: 'desc' })
    }
  }

  const sortFunction = investment => {
    const { sortBy } = state

    if (sortBy === 'balance') {
      return investment.totalValue
    }

    if (sortBy === 'name') {
      return investment.securities.securityName
    }
  }

  const sortActive = (active, sortOrder) => {
    if (!active) {
      return 'neutral'
    }

    if (sortOrder === 'asc') {
      return 'up'
    }

    if (sortOrder === 'desc') {
      return 'down'
    }
  }

  const { sortBy, sortOrder } = state
  const {
    store: {
      features: { editInstitutionalAccount },
    },
  } = props
  const { title, balanceLabel, balance, investments } = props
  const sortedInvestments = _.orderBy(investments, sortFunction, [sortOrder])

  return (
    <div>
      <TableTitle>
        <div>
          {title}{' '}
          {title === 'After-tax investments' && <HelpIcon tooltip={TooltipText.costBasis()} />}
          &nbsp;&nbsp;&nbsp;
        </div>
        <BalanceLabel>
          {balanceLabel} <Balance>${numberToDollars(balance)}</Balance>
        </BalanceLabel>
      </TableTitle>

      <TableHeader>
        <div>Investment type</div>
        <div>Ticker</div>
        <div onClick={() => handleSortChange('name')}>
          Investment name <SortArrow direction={sortActive(sortBy === 'name', sortOrder)} />
        </div>
        <div onClick={() => handleSortChange('balance')}>
          Balance <SortArrow direction={sortActive(sortBy === 'balance', sortOrder)} />
        </div>
      </TableHeader>

      <TableList>
        {sortedInvestments.map(investment => {
          const {
            totalValue,
            id,
            securities: { securityType, ticker, securityName },
          } = investment

          return (
            <div key={id}>
              {editInstitutionalAccount ? (
                <InvestmentGroupItem
                  accountId={props.accountId}
                  canEdit={props.canEdit}
                  investment={investment}
                  toggleEdit={props.toggleEdit}
                />
              ) : (
                <TableRow key={id}>
                  <div>{SECURITY_TYPES_TEXT[securityType]}</div>
                  <div>{ticker}</div>
                  <div>{placeholderSymbolReplace(securityName)}</div>
                  <div>${numberToDollars(totalValue)}</div>
                </TableRow>
              )}
            </div>
          )
        })}
      </TableList>
    </div>
  )
}

export default withRouterProps(inject('store')(observer(InstitutionalInvestmentsGroup)))
